import Velocity from 'velocity-animate';

export default function initTab () {
	const tabNavLinks = document.querySelectorAll('.tabs .tab-nav__item a');

	if (!tabNavLinks.length) return;

	const initialTabId = location.hash ? location.hash : [...tabNavLinks][0].hash;
	document.querySelector(initialTabId).classList.add('tab__item_active');
	const initNavItem = [...tabNavLinks].filter(l => l.hash === initialTabId)[0].parentNode;

	initNavItem.classList.add('tab-nav__item_active');

	const navInner = document.querySelector('.tab-nav__list');
	const navContainer = navInner.parentNode;
	alignActiveNavItem(initNavItem, navInner, navContainer);

	[...tabNavLinks].map(link => {
		link.addEventListener('click', function (e) {
			e.preventDefault();

			[...tabNavLinks].map(l => l.parentNode.classList.remove('tab-nav__item_active'));
			this.parentNode.classList.add('tab-nav__item_active');
			alignActiveNavItem(this.parentNode, navInner, navContainer);

			const tab = document.querySelectorAll('.tabs .tab__item');
			[...tab].map(tab => tab.classList.remove('tab__item_active'));

			document.querySelector(this.hash).classList.add('tab__item_active');

			history.pushState({}, '', this.hash);
		});
	});
}

function alignActiveNavItem (item, inner, container) {
	if (window.innerWidth > 1000) return;

	const leftEdge = inner.offsetLeft;
	const rightEdge = inner.offsetLeft + inner.offsetWidth;
	const navItemLeft = item.getBoundingClientRect().left;
	const navItemRight = item.getBoundingClientRect().right;

	const outOfBoundaries = (navItemLeft < leftEdge) || (navItemRight > rightEdge);

	if (outOfBoundaries) {
		const options = {
			container,
			duration: 400,
			axis: 'x'
		}

		if (navItemLeft < leftEdge) {
			options.offset = -leftEdge;
		}

		Velocity(item, 'scroll', options);
	}
}
